module.exports = __webpack_public_path__ + "static/img/ic_ask@3x.04a2d21d.png";